<script setup>
  defineOptions({name: "PagesRecordResultSummaryForPrint"});

  defineProps({
    record: {
      type: Object,
      required: true,
    },
  });
</script>

<template>
  <section
    v-if="record.doctorsummary || record.patientsummary || record.usersummary"
    class="hidden space-y-6 border-2 p-2 print:block"
  >
    <div v-if="record.doctorsummary" class="flex justify-between space-x-4">
      <div class="hidden print:break-inside-avoid-page in-[.print-archive]:print:block in-[.print-doc]:print:block">
        <strong class="text-lg font-normal">Zusammenfassung an Arzt (Fachkreise):</strong>
        <!-- eslint-disable-next-line vue/no-v-html -- summary is Trix rich text edited in ResultSummary.vue and stored as HTML -->
        <div class="print:break-before-avoid-page" v-html="record.doctorsummary" />
      </div>

      <div
        v-if="$page.props.client.license.is_pro && record.feedback_url"
        class="mt-4 hidden print:hidden in-[.print-doc.print-with-doctor-feedback]:print:block"
      >
        <a :href="record.feedback_url" target="_blank" class="rounded bg-mcred p-1 font-semibold text-white">
          Rückmeldung geben
        </a>
        <div class="mt-2 text-xs leading-tight">zur Zusammenfassung</div>
      </div>
    </div>

    <div
      v-if="record.patientsummary"
      class="hidden print:break-inside-avoid-page in-[.print-archive]:print:block in-[.print-patient]:print:block"
    >
      <strong class="text-lg font-normal">Zusammenfassung an Patienten:</strong>
      <!-- eslint-disable-next-line vue/no-v-html -- summary is Trix rich text edited in ResultSummary.vue and stored as HTML -->
      <div class="print:break-before-avoid-page" v-html="record.patientsummary" />
    </div>

    <div v-if="record.usersummary" class="hidden print:break-inside-avoid-page in-[.print-archive]:print:block">
      <strong class="text-lg font-normal">Notizen:</strong>
      <!-- eslint-disable-next-line vue/no-v-html -- summary is Trix rich text edited in ResultSummary.vue and stored as HTML -->
      <div class="print:break-before-avoid-page" v-html="record.usersummary" />
    </div>
  </section>
</template>
